import React from 'react'

import DefaultCarousel from 'src/components/DefaultCarousel'
import ScrollTo from 'src/components/ScrollTo/ScrollTo'
import { orange } from 'src/styles/colors'
import useWidth from 'src/hooks/useWidth'
import { widths } from 'src/styles/breakpoints'

import IcHandMoney from '@interco/icons/core/human/ic_hand_money'
import IcPadlock from '@interco/icons/core/privacy-security/ic_padlock'
import IcPig from '@interco/icons/build-v4/orangeds/MD/pig'
import IcCalculator from '@interco/icons/core/home-objects/ic_calculator'

import data from '../../assets/data/exclusive-content.json'
import { Section, BoxCard, Button } from './style'

const Icon = ({
  name,
  width,
  height,
  color,
}: {
  name: string
  width: number
  height: number
  color: string
}) => {
  switch (name) {
    case 'ic_hand_money':
      return <IcHandMoney width={width} height={height} color={color} />
    case 'ic_padlock':
      return <IcPadlock width={width} height={height} color={color} />
    case 'ic_calculator':
      return <IcCalculator width={width} height={height} color={color} />
    case 'ic_pig':
      return <IcPig width={width} height={height} color={color} />
    default:
      return null
  }
}

const ExclusiveContent = () => {
  const width = useWidth()

  return (
    <Section className="py-5" id="conteudo-exclusivo">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="fs-24 fs-md-28 fs-lg-40 fs-xl-50 text-white text-center">
              Conteúdo exclusivo <span>para quem investe</span>{' '}
            </h2>
            <p className="fs-16 fs-xl-20 text-white mb-4 text-center subtitle">
              Esteja à frente do mercado com insights estratégicos e análises em tempo real.
            </p>
          </div>
          <div className="col-12">
            <DefaultCarousel
              sm={{ items: 1, partialVisibilityGutter: 90 }}
              md={{ items: 3 }}
              lg={{ items: 4 }}
              xl={{ items: 4 }}
              itemClass="px-2"
              containerClass="carrossel"
            >
              {data.map((item) => (
                <BoxCard key={item.description}>
                  <Icon
                    name={item.icon}
                    width={width <= widths.lg ? 18.75 : 22.67}
                    height={width <= widths.lg ? 18.75 : 22.67}
                    color={orange.base}
                  />
                  <h3 className="fs-18 fs-xl-22 fs-xl-22 lh-xl-26 text-white fw-500">
                    {item.title}
                  </h3>
                  <p className="fs-12 fs-xl-16 text-white fw-400 mb-0">{item.description}</p>
                </BoxCard>
              ))}
            </DefaultCarousel>
            <div className="d-flex align-items-center justify-content-center">
              <ScrollTo to="#hero-modal-form" title="Receba em primeira mão">
                <Button>Receba em primeira mão</Button>
              </ScrollTo>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ExclusiveContent
